module.exports = __webpack_public_path__ + "img/6.c6e78913.png";